import { Link } from 'gatsby';
import { OutboundLink } from 'gatsby-plugin-google-analytics';
import { HTMLSerializer } from 'prismic-reactjs';
import React from 'react';

export const hyperlinkSerializer: HTMLSerializer = (type, element, content, children, key) => {
  if (!content || content.trim() === '') return <React.Fragment key={key} />;

  if (element.data?.link_type === 'Web') {
    return (
      <OutboundLink
        key={key}
        href={element.data.url}
        target="_blank"
        rel="noopener noreferrer"
      >
        {content}
      </OutboundLink>
    );
  }

  if (element.data?.link_type === 'Document') {
    return (
      <Link key={key} to={`/${element.data.uid}`}>
        {content}
      </Link>
    );
  }

  return null;
};

export const htmlSerializer: HTMLSerializer = (type, element, content, children, key) => {
  // skip empty
  if (type === 'paragraph' && (!element.text || element.text.trim() === '')) {
    return <React.Fragment key={key} />;
  }

  // hyperlink
  if (element.type === 'hyperlink') return hyperlinkSerializer(type, element, content, children, key);

  // giphy
  // if (element.type === 'embed' && element.oembed?.provider_name === 'GIPHY') {
  //   if (element.oembed.url && element.oembed.width && element.oembed.height) {
  //     const giphyIdMatch = element.oembed.url?.match(/giphy\.com\/media\/(.+)\/giphy/);
  //     if (giphyIdMatch && giphyIdMatch[1]) {
  //       const { width, height } = scaledImageDimensions(600, 800, element.oembed.width, element.oembed.height);

  //       return (
  //         <div key={key} className="embed embed-giphy">
  //           <div style={{ width, height }}>
  //             {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
  //             <video key={key} loop autoPlay muted playsInline>
  //               <source src={`https://media.giphy.com/media/${giphyIdMatch[1]}/giphy.mp4`} type="video/mp4" />
  //             </video>
  //           </div>

  //           <i>
  //             <a href={element.oembed.embed_url ?? element.oembed.url} target="_blank" rel="noopener noreferrer">
  //               via GIPHY
  //             </a>
  //           </i>
  //         </div>
  //       );
  //     }
  //   }
  // }

  return null;
};
